import { FC, useEffect, useState } from 'react';
import { getInitials } from '@component/DriverChat/helpers';

type DriverAvatarProps = {
  name: string;
  image?: string;
  size?: 'xs' | 'sm' | 'md';
  presence?: 'online' | 'reconnecting' | 'offline';
};

export const DriverAvatar: FC<DriverAvatarProps> = ({
  name,
  image,
  size = 'md',
  presence,
}) => {
  const [imageFailed, setImageFailed] = useState(false);

  useEffect(() => setImageFailed(false), [image]);
  const showImage = !!image && !imageFailed;

  return (
    <span className={`dc-avatar dc-avatar--${size}`} aria-hidden="true">
      {showImage ? (
        <img src={image} alt="" onError={() => setImageFailed(true)} />
      ) : (
        getInitials(name)
      )}
      {presence && (
        <span
          className={`dc-avatar__presence dc-avatar__presence--${presence}`}
        />
      )}
    </span>
  );
};
